import { useTouchEditStore } from './touchEditStore';

export const useTouchEditVisible = () =>
	useTouchEditStore(state => state.visible);

export const useToggleTouchEditVisible = () =>
	useTouchEditStore(state => state.toggleVisible);

export const useHideTouchEditVisible = () =>
	useTouchEditStore(state => state.hideVisible);
